export const DATA_TYPE_MAP = {
    year: 'year',
    sqft: 'sqft',
    money: 'money',
    float: 'float',
    days: 'days',
    date: 'date',
    none: 'none'
};
export const mobileOutFields = [
    'minPrice-maxPrice',
    'More-Than-Beds',
    'More-Than-Baths'
];
// export const searchModuleType = {
//     bigMap: 'big-map',
//     gridList: 'grid-list'
// };
export function localStorageSortKey() {
    return `${window.location.pathname}:Sort`;
}
export function localStorageViewPatternKey() {
    return `${window.location.pathname}:ViewPattern`;
}
export const cmsConfigKeys = [
    'listingSource',
    // 'presetFilters',
    // 'presetFiltersV2',
    'sortConfigs',
    // 'showSearchBar',
    'centerPoint',
    'zoom',
    'property_gathering_amount'
];
